import { Component, Prop, h, Host } from "@stencil/core";

@Component({
	tag: "smart-text",
	styleUrl: "smart-text.scss",
	shadow: true,
})

export class SmartText {
	@Prop() as: keyof HTMLElementTagNameMap | "host" = "host";
	@Prop() variant: "headline-1" | "headline-2" | "headline-3" | "headline-4" | "headline-5" | "headline-6" | "subtitle-1" | "subtitle-2" | "bodytext-1" | "bodytext-2" | "caption" | "overline" = "headline-1";

	render() {
		const Tag = this.as === "host" ? Host : this.as;

		return (
			<Tag part='text-element' class={this.variant}>
				<slot></slot>
			</Tag>
		);
	}
}

